import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const SIGNATURE_CANVAS_WIDTH = 560;
const SIGNATURE_CANVAS_HEIGHT = 180;

function PaymentSignatureCanvas({ onSignatureChange }) {
  const { t } = useTranslation();
  const canvasRef = useRef(null);
  const isDrawingRef = useRef(false);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext("2d");
    context.lineJoin = "round";
    context.lineCap = "round";
    context.lineWidth = 2;
    context.strokeStyle = "#111";
    context.clearRect(0, 0, canvas.width, canvas.height);
  }, []);

  const drawAt = (x, y) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    context.lineTo(x, y);
    context.stroke();
  };

  const handlePointerDown = (event) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const bounds = canvas.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    const context = canvas.getContext("2d");

    context.beginPath();
    context.moveTo(x, y);
    isDrawingRef.current = true;
  };

  const handlePointerMove = (event) => {
    if (!isDrawingRef.current) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const bounds = canvas.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    drawAt(x, y);
    if (isEmpty) {
      setIsEmpty(false);
    }
  };

  const emitSignatureChange = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dataUrl = isEmpty ? "" : canvas.toDataURL("image/png");
    onSignatureChange(dataUrl);
  };

  const handlePointerUp = () => {
    isDrawingRef.current = false;
    emitSignatureChange();
  };

  const handleClear = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    setIsEmpty(true);
    onSignatureChange("");
  };

  return (
    <div className="signature-block">
      <canvas
        ref={canvasRef}
        className="signature-canvas"
        width={SIGNATURE_CANVAS_WIDTH}
        height={SIGNATURE_CANVAS_HEIGHT}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerLeave={handlePointerUp}
      />
      <div className="signature-actions">
        <button
          type="button"
          className="signature-clear-btn"
          onClick={handleClear}
        >
          {t("payment.clearSignature")}
        </button>
      </div>
    </div>
  );
}

export default PaymentSignatureCanvas;
